// Validate redirect URL to prevent open redirect attacks
import { devError } from "@/utils/dev-console";

const ALLOWED_REDIRECT_PATTERNS = [
  /^\/learn\/.+$/,
  /^\/products\/.+\/download$/,
  /^\/products\/.+\/booking$/,
  /^\/dashboard$/,
];

export function validateRedirectUrl(url: string): string {
  try {
    // Remove any query params and hash
    const cleanUrl = url.split('?')[0].split('#')[0];

    // Check if it matches allowed patterns
    const isAllowed = ALLOWED_REDIRECT_PATTERNS.some((pattern) =>
      pattern.test(cleanUrl)
    );

    if (isAllowed && !cleanUrl.includes('..') && cleanUrl.startsWith('/')) {
      return cleanUrl;
    }

    // Default safe redirect
    return '/dashboard';
  } catch (error) {
    devError('Invalid redirect URL', url, error);
    return '/dashboard';
  }
}
